import { useBatchedSimplePerson } from "@/-dataloaders/simple-persons"
import { usePersonAttachmentApi } from "@/attachment-api/person-attachment-api"
import { Avatar, AvatarProps } from "@mantine/core"

interface Props extends Omit<AvatarProps, "src" | "size" | "name"> {
  personId?: number
  size?: number
  onClick?: () => void
  fallbackName?: string
}
export function PersonProfilePictureAvatar({
  personId,
  size,
  fallbackName,
  ...props
}: Props) {
  const { data: person } = useBatchedSimplePerson(personId)
  const attachmentApi = usePersonAttachmentApi()
  const { profilePictureId } = person ?? {}
  const profilePicture =
    personId && profilePictureId
      ? attachmentApi.getThumbnailUrl(
          profilePictureId,
          personId,
          size ? size * 4 : 320,
          false
        )
      : undefined

  return (
    <Avatar
      color="initials"
      size={size}
      src={profilePicture ?? undefined}
      {...props}
      name={person?.name ?? fallbackName}
    />
  )
}
